(function(){
    angular
        .module('appback')
        .filter('formatearNumero', formatearnumero);

        formatearnumero.$inject = ['$sce'];
        function formatearnumero($sce){
            return function (input) {
              console.log("input",input);
             if (!isNaN(input)) {
                // Convertir el input a número
                var numero = parseFloat(input);

                // Usar toLocaleString para formatear con punto como separador de miles
                return numero.toLocaleString('es-ES', {
                  minimumFractionDigits: numero % 1 === 0 ? 0 : 2,
                  maximumFractionDigits: 2
                });
              } else {
                return input;
              }
          };
      }
})();